import React, { FC } from 'react'

import { useLocation } from 'react-router'

import { CameraSvg } from 'components/designSystem/svgr/CameraSvg'
import {
  albumPath,
  uploadPhotosPath,
} from 'components/page/UploaderPhotos/Uploader.paths'
import { RouterLink } from 'components/presentational/link'
import { mergeAllUrls } from 'functions/mergeAllUrls'
import { useIsCurrentUser } from 'hooks/useIsCurrentUser'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const Upload: FC = () => {
  const { id } = useShallowEqualSelector(
    ({ photoAlbumReducer: { totalPhotos, id } }) => ({
      totalPhotos,
      id,
    })
  )

  const isCurrentUser = useIsCurrentUser(String(id))
  const { pathname } = useLocation()

  if (isCurrentUser) {
    return (
      <RouterLink
        to={mergeAllUrls(pathname, uploadPhotosPath, albumPath)}
        data-name="upload-action"
      >
        <CameraSvg
          width={32}
          height={32}
          style={{ color: 'var(--foreground-default)' }}
        />
      </RouterLink>
    )
  }

  return null
}
